const s = {
  name: "Diversity",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,6l-6-6l-6,6l6,6L24,6z M18,9.2L14.8,6L18,2.8L21.2,6L18,9.2z"/>
		<path class="st0" d="M22.5,15h-9v9h9V15z M15.5,22v-5h5v5H15.5z"/>
		<path class="st0" d="M6,13l6,11H0L6,13z M3.4,22h5.2L6,17.2L3.4,22z"/>
		<path class="st0" d="M6,1C3.2,1,1,3.2,1,6c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5C11,3.2,8.8,1,6,1z M3,6c0-1.7,1.3-3,3-3s3,1.3,3,3
			S7.7,9,6,9S3,7.7,3,6z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Diversity
};
